import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import i18n from "i18next";
import { LuFolder, LuFolderOpen, LuPalette, LuUpload } from "react-icons/lu";
import "./_libraryNav.scss";

const CATEGORIES = [
  { key: "Upload Files", i18nKey: "upload_files", Icon: LuUpload },
  { key: "My Files", i18nKey: "my_files", Icon: LuFolder },
  { key: "Organization Files", i18nKey: "org_files", Icon: LuFolderOpen },
  { key: "Brand", i18nKey: "brand_files", Icon: LuPalette },
];

const LibraryPanel = ({ onCategorySelected, selectedCategory }) => {
  const [internalSelected, setInternalSelected] = useState(selectedCategory ?? null);
  const activeCategory = selectedCategory ?? internalSelected;

  useEffect(() => {
    setInternalSelected(selectedCategory ?? null);
  }, [selectedCategory]);

  const handleSelect = (key) => {
    setInternalSelected(key);
    onCategorySelected?.(key);
  };

  return (
    <div className="lib-nav">
      {CATEGORIES.map(({ key, i18nKey, Icon }) => (
        <button
          key={key}
          type="button"
          className={`lib-nav__item${activeCategory === key ? " is-active" : ""}`}
          onClick={() => handleSelect(key)}
        >
          <Icon size={20} />
          <span className="lib-nav__label">{i18n.t(i18nKey) || key}</span>
        </button>
      ))}
    </div>
  );
};

LibraryPanel.propTypes = {
  onCategorySelected: PropTypes.func,
  selectedCategory: PropTypes.string,
};

export default LibraryPanel;
